import { withStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme';

export default withStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.6em',
    },
    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
    },
  },
  root: {
    background: theme.palette.grey['100'],
    borderRadius: '4px',
    border: '1px solid #E0E0E0',
  },
  tabsIndicator: {
    backgroundColor: 'white',
    height: '100%',
    zIndex: 1,
    borderRadius: '4px 4px 0 0',
  },
  tabRoot: {
    color: '#818B9D',
    borderRadius: '4px 4px 0 0',
    textTransform: 'initial',
    minWidth: 72,
    fontWeight: 400,
    '&:hover': {
      color: '#818B9D',
      opacity: 1,
    },
    '&:focus': {
      color: '#192542',
    },
  },
  label: {
    position: 'relative',
    zIndex: 2,
    fontSize: 16,
  },
  tabSelected: {
    color: '#192542',
    fontWeight: 500,
    boxShadow: theme.shadows[1],
  },
  typography: {
    padding: theme.spacing(2) * 3,
  },
  buttonCopy: {
    background: '#818B9D',
    color: '#fff',
    '&:hover': {
      background: '#192542',
      color: '#fff',
    },
  },
  tabContainer: {
    background: 'white',
    borderRadius: '4px 4px 0 0',
    padding: 16,
    boxShadow: theme.shadows[1],
    flex: 1,
    minHeight: '100%',
  },
  input: {
    position: 'relative',
  },
  money: {
    textAlign: 'right',
  },
  bootstrapRoot: {
    padding: 0,
    ['label + &' as any]: {
      marginTop: theme.spacing(2) * 3,
    },
  },
  bootstrapInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  bootstrapFormLabel: {
    fontSize: 18,
  },
  fieldModified: {
    color: '#fabb0a',
    float: 'right',
    fontSize: 16,
    marginTop: '-30px',
  },
  variationWrapper: {
    display: 'flex',
    justifyItems: 'stretch',
  },
  deleteLink: {
    '&:hover': {
      color: '#dc3f53',
      cursor: 'pointer',
    },
  },
  badgeTab: {
    position: 'relative',
    top: 13,
    backgroundColor: '#dc3f53',
    left: -6,
  },
  badgeTabInvisible: {},
  saving: {
    textAlign: 'center',
    background: '#fff',
    padding: '20px',
  },
  variationTabs: {
    width: '80%',
    float: 'left',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 2,
  },
  variationMenu: {
    width: '20%',
    float: 'left',
    display: 'flex',
    justifyItems: 'stretch',
    flexDirection: 'column',
    flexGrow: 1,
    ['& > span' as any]: {
      height: 48,
      lineHeight: '48px',
      color: '#192542',
      padding: '0 1rem',
    },
  },
  variationList: {
    background: '#eee',
    boxShadow: '0 3px 2px 0 rgba(0,0,0,0.06), 0 5px 10px 0 rgba(0,0,0,0.02)',
    borderRadius: '4px 0 0 4px',
    flex: 1,
    overflow: 'hidden',
  },
  variationButton: {
    fontSize: 14,
    color: '#8E97A7',
    textAlign: 'left',
    borderRadius: 0,
    textTransform: 'none',
    fontWeight: 400,
    padding: '1rem 1.5rem',
    width: '100%',
    ['&.active' as any]: {
      color: '#192542',
      backgroundColor: 'rgba(0,0,0,0.1)',
    },
    '&:hover': {
      color: '#192542',
    },
  },
  loadingPages: {
    width: '100%',
    textAlign: 'center',
  },
  chipStatus: {
    color: '#ffff',
    height: 26,
    ['&.Pendente' as any]: {
      backgroundColor: '#fabb0a',
    },
    ['&.Aprovado' as any]: {
      backgroundColor: 'green',
    },
    ['&.Reprovado' as any]: {
      backgroundColor: variables.palette.error.main,
    },
    ['&.Cancelado' as any]: {
      backgroundColor: variables.palette.error.main,
    },
    ['&.Removido' as any]: {
      backgroundColor: variables.palette.error.main,
    },
  },
  listVariations: {
    width: '20%',
    paddingTop: 0,
    backgroundColor: '#ffffff',
    marginRight: 2,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,0.07)',
    borderRadius: '0 4px 4px 0',
  },
  iconList: {
    width: 20,
  },
  list: {
    background: 'white',
    overflow: 'auto',
    padding: 0,
    maxHeight: 580,
    boxShadow: '0 4px 10px 0 rgb(0 0 0 / 7%)',
  },
  allList: { position: 'sticky', top: 0, zIndex: 10, background: 'white' },
  topList: {
    position: 'sticky',
    maxHeight: '100vh',
    zIndex: 10,
    background: 'white',
  },
  filter: { border: '1px solid rgb(224, 224, 224)', padding: 12, borderRadius: 4 },
  statusCard: {
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '6px 16px',
    fontSize: '0.775rem',
    fontWeight: 500,
    lineHeight: '1.75',
    borderRadius: 4,
    letterSpacing: '0.02857em',
    textTransform: 'uppercase',
  },
  saveContext: {
    marginTop: 20,
  },
  saveButtonDiv: {},
  draftButton: {
    marginRight: 8,
  },
  saveButton: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  content: {
    background: 'white',
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    flex: 1,
    marginBottom: theme.spacing(2),
  },
  titleContent: {
    position: 'sticky',
    top: 0,
    backgroundColor: '#ffff',
    zIndex: 100,
    borderBottom: '1px solid #eadada99',
  },
  title: {
    color: '#192542',
    padding: theme.spacing(2),
    textTransform: 'uppercase',
    fontSize: '1.1rem',
    fontWeight: 500,
  },
  form: {
    padding: theme.spacing(2),
  },
  formSubmiting: {
    padding: theme.spacing(2),
    opacity: '0.3',
  },
  loadingLinear: {
    width: '100%',
  },
}));
